/**
 * Calculates MSNQ-score or total filled fields for historyview
 */

import { getLatestCommitData } from 'lib/documentHandling';
import { calculateMSNQTotal } from 'neuro-calculation-commons';

// Calculate total filled fields per document
const calculateMSNQTotals = d => {
  for (let i = 0; i < d.length; i++) {
    d[i] = {
      ...d[i],
      ...calculateMSNQTotal(getLatestCommitData(d[i])),
    };
  }
  return d;
};

export default calculateMSNQTotals;
